import {
  configEnvToStr,
  fetchConfiguration,
  selectAppConfigById,
} from "@app/deploy";
import { useApi, useSelector } from "@app/react";
import { useMemo, useState } from "react";
import { ButtonFullVisibility } from "../button";
import { Group } from "../group";
import { PreBox } from "../pre-code";

export const AppConfigView = ({
  configId,
  envId,
}: { configId: string; envId: string }) => {
  const [isVisible, setVisible] = useState(false);
  const config = useSelector((s) => selectAppConfigById(s, { id: configId }));
  const envStr = configEnvToStr(config.env);

  // Fetch the configuration for the given configId
  const action = useMemo(
    () => fetchConfiguration({ id: configId, withSensitiveExtras: true }),
    [configId],
  );
  const loader = useApi(action);

  const onShow = () => {
    loader.trigger();
    setVisible(true);
  };

  // Show message if configId is empty
  if (!configId) {
    return (
      <div className="text-gray-500">This app has no configuration yet.</div>
    );
  }

  return (
    <>
      {isVisible ? (
        <Group size="sm">
          <div>
            <ButtonFullVisibility
              envId={envId}
              variant="white"
              onClick={() => setVisible(false)}
            >
              Hide
            </ButtonFullVisibility>
          </div>
          {loader.isLoading || config.id === "" ? (
            <div className="text-gray-500">Loading configuration...</div>
          ) : envStr === "" ? (
            <div className="text-gray-500">
              There are no environment variables for this app.
            </div>
          ) : (
            <PreBox
              allowCopy
              segments={[{ text: envStr, className: "text-white" }]}
            />
          )}
        </Group>
      ) : (
        <div>
          <ButtonFullVisibility envId={envId} variant="white" onClick={onShow}>
            Show
          </ButtonFullVisibility>
        </div>
      )}
    </>
  );
};
